import React, { useState, useEffect } from "react";
import { Paginator } from "../../../layout/Paginator/Paginator";
import { Search } from "../../../layout/Table/Search";
import { CertificatesTableComponent } from "../../certificateManagement/table/CertificatesTableComponent";
import { Messages } from "../../../../components/layout/Messages/Messages";
import { ACL } from '../../../../config/constants';
import { RowsPerPage } from "../../../layout/Table/RowsPerPage";
import { store } from '../../../../store/store';
import { hideNotification } from '../../../../store/actions/notification';
import { FiltersList } from "../../../../components/shared/filters/FiltersList";
import { useUpdateEffect } from '../../../../helpers/hooks';
import { ListToolbar } from '../../../layout/Workspace';

function ClientCertificatesTab(props) {
  const [sortDirection, setSortDirection] = useState(null);
  const [sortField, setSortField] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const [filters, setFilters] = useState( {
    statuses: []
  } );
  const {user, getUserCertificates, certificates, metaCertificates, rowsPerPageCertificates, setRowsPerPageCertificates} = props;
  const shouldRenderFields = true;

  useEffect( () => {
    if (user && getUserCertificates) {
      getUserCertificates(user.id, 1, sortField, sortDirection, searchText, filters);
    }

    return () => {
      store.dispatch(hideNotification());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPageCertificates] );

  useUpdateEffect( () => {
    getUserCertificates(user.id, 1, sortField, sortDirection, searchText, filters );

    return () => {
      store.dispatch( hideNotification() );
    }
  }, [ filters ] ); // eslint-disable-line react-hooks/exhaustive-deps

  /**
   * Apply sort by appliedSortField
   * @param {string} appliedSortField
   */
  function applySort(appliedSortField) {
    let newSortDirection = "";

    if (sortField) {
      if (sortField === appliedSortField) {
        newSortDirection = sortDirection === "asc" ? "desc" : "asc";
      } else {
        newSortDirection = "asc";
      }
    } else {
      newSortDirection = "asc";
    }

    setSortField(appliedSortField);
    setSortDirection(newSortDirection);

    getUserCertificates(user.id, metaCertificates.current_page, appliedSortField, newSortDirection, searchText, filters, true);
  }

  const applyFilters = (key, data) => {
    setFilters( {
      ...filters,
      [key]: data
    } );

  }

  const removeAllFilters = () => {
    setFilters( {
      statuses: [],
    } );
  }

  const removeFilter = item => {
    setFilters( {
      ...filters,
      [item.key]: filters[item.key].filter( elem => elem.identifier !== item.identifier )
    } );
  }

  return (
    <section className="user-detail-section">
      <div className="user-detail-section__messages">
        <Messages/>
      </div>
      <ListToolbar
        activeFilters={(
          <FiltersList
            id="filters"
            filters={filters}
            filterList="certificates"
            onRemoveFilter={removeFilter}
            onRemoveAllFilters={removeAllFilters}
          />
        )}
        className="user-detail-list-toolbar"
        search={ACL.CLIENT.USERS.SEARCH.hasAccess() ? (
          <Search
              search={(searchText) => {
                setSearchText(searchText);
                getUserCertificates(user.id, 1, null, null, searchText, filters, true);
              }}
              id="certificates"
          />
        ) : null}
      />
      <div className="user-detail-table">
        <CertificatesTableComponent
          certificates={certificates}
          shouldRenderFields={shouldRenderFields}
          applyFilters={applyFilters}
          applySort={sortField => applySort( sortField )}
          filters={filters}
          actionCallback={(useState) => {
            if (useState) {
              getUserCertificates(
                user.id,
                metaCertificates.current_page,
                sortField,
                sortDirection,
                searchText,
                filters
              );
            }
            getUserCertificates(user.id, 1, sortField, sortDirection, searchText, filters);
          }}
        />
      </div>
      <Paginator
        meta={metaCertificates}
        settings={(
          <RowsPerPage
            changeRowsPerPage={(rowsPerPage) => {
              setRowsPerPageCertificates(rowsPerPage);
            }}
            id="certificates"
          />
        )}
        changePage={(page) =>
          getUserCertificates(user.id, page, sortField, sortDirection, searchText, filters, true)
        }
      />
    </section>
  );
}

export { ClientCertificatesTab };
